import React from 'react'
import { GET_UCC_XML_USERS } from 'requests'
import Toolbar from 'components/Table/Toolbar'
import ListBlock from 'components/ListBlock/ListBlock'
import GearsIcon from '@tecuity/sos-icons/react/gears'
import { Drawer } from 'components/Shell/Shell'
import SavedPaymentsDrawer from './SavedPaymentsDrawer'
import './SavedPayments.scss'

const SavedPayments = ({ setDrawerShown, drawerShown }) => {
  const [users, setUsers] = React.useState([])
  const [selectedProfileId, setSelectedProfileId] = React.useState(null)
  const [drawerTitle, setDrawerTitle] = React.useState('')
  const [drawerSubtitle, setDrawerSubtitle] = React.useState('')

  React.useEffect(() => {
    GET_UCC_XML_USERS(
      users => {
        setUsers(users)
      },
      err => {
        console.error(err)
      }
    )
  }, [])

  const selectUser = (profileId, title, subtitle) => {
    if (profileId === selectedProfileId) {
      setSelectedProfileId(null)
      setDrawerShown(false)
    } else {
      setSelectedProfileId(profileId)
      setDrawerTitle(title)
      setDrawerSubtitle(subtitle)
      setDrawerShown(true)
    }
  }
  return (
    <div className="saved-payments">
      <Toolbar title="Saved Payments" searchable={false} />
      <ul className="list-wrapper">
        {users.map(user => (
          <ListBlock
            title={user.USER_NAME}
            subtitle={user.EMAIL}
            buttons={[
              {
                label: <GearsIcon />,
                ariaLabel: 'Edit User Payments',
                id: 'view',
                onClick: () =>
                  selectUser(user.CUSTOMER_PROFILE_ID, user.USER_NAME, user.EMAIL)
              }
            ]}
            key={user.CUSTOMER_PROFILE_ID}
          />
        ))}
      </ul>
      <Drawer
        show={drawerShown}
        title={drawerTitle}
        subtitle={drawerSubtitle}
        onSidebarDismiss={() => setDrawerShown(false)}
      >
        <SavedPaymentsDrawer profileId={selectedProfileId}/>
      </Drawer>
    </div>
  )
}

export default SavedPayments



// WEBPACK FOOTER //
// ./src/components/SavedPayments/SavedPayments.js